import { Action } from 'redux';

import { HideRecommendation, RecommendationHidden, RecommendationUnhidden, UndoHideRecommendation } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';

export type DismissibleRecommendationType = 'recommendedView';

export interface HideRecommendationAction extends Action {
  contentId: string;
  contentType: DismissibleRecommendationType;
  contentName: string;
}

export function hideRecommendation(contentId: string,
                                   contentType: DismissibleRecommendationType,
                                   contentName: string): HideRecommendationAction {
  return {
    type: HideRecommendation,
    contentId,
    contentType,
    contentName
  };
}

export const isHideRecommendationAction = isActionFactory<HideRecommendationAction>(HideRecommendation);

export interface RecommendationHiddenAction extends Action {
  contentId: string;
  contentType: DismissibleRecommendationType;
}

export function recommendationHidden(contentId: string, contentType: DismissibleRecommendationType) {
  return {
    type: RecommendationHidden,
    contentId,
    contentType
  };
}

export const isRecommendationHiddenAction = isActionFactory<RecommendationHiddenAction>(RecommendationHidden);

export interface UndoHideRecommendationAction extends Action {
  contentId: string;
  contentType: DismissibleRecommendationType;
}

export function undoHideRecommendation(contentId: string, contentType: DismissibleRecommendationType): UndoHideRecommendationAction {
  return {
    type: UndoHideRecommendation,
    contentId,
    contentType
  };
}

export const isUndoHideRecommendationAction = isActionFactory<UndoHideRecommendationAction>(UndoHideRecommendation);

export interface RecommendationUnhiddenAction extends Action {
  contentId: string;
  contentType: DismissibleRecommendationType;
}

export function recommendationUnhidden(contentId: string, contentType: DismissibleRecommendationType) {
  return {
    type: RecommendationUnhidden,
    contentId,
    contentType
  };
}

export const isRecommendationUnhiddenAction = isActionFactory<RecommendationUnhiddenAction>(RecommendationUnhidden);
